import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  CircularProgress,
} from "@mui/material";
import { MAP_LAYERS } from "../../config/mapLayers";

const LayerDropdown = ({
  layers = MAP_LAYERS,
  selectedLayer,
  onLayerChange,
  layerLoading,
  layerMeta,
  layerError,
}) => {
  return (
    <Box sx={{ width: "100%", maxWidth: 420, mx: "auto", px: 1, py: 0.5 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <FormControl size="small" fullWidth>
          <InputLabel id="map-layer-select-label">Map overlay</InputLabel>
          <Select
            labelId="map-layer-select-label"
            id="map-layer-select"
            value={selectedLayer}
            label="Map overlay"
            onChange={(e) => onLayerChange(e.target.value)}
          >
            <MenuItem value="">
              <em>Show all facilities only</em>
            </MenuItem>
            {layers.map((layer) => (
              <MenuItem key={layer.categoryId} value={layer.categoryId}>
                {layer.categoryLabel}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {layerLoading ? <CircularProgress size={22} /> : null}
      </Box>
      {layerError && (
        <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
          {layerError}
        </Typography>
      )}
      {selectedLayer && layerMeta && !layerError && (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
          {layerMeta.categoryLabel}
          {layerMeta.sourceUrl ? (
            <>
              {" · "}
              <a href={layerMeta.sourceUrl} target="_blank" rel="noopener noreferrer">
                Source
              </a>
            </>
          ) : null}
        </Typography>
      )}
    </Box>
  );
};

export default LayerDropdown;
